import { InfoOutlined } from "@material-ui/icons";
import { Box, CircularProgress, Divider, IconButton, Popover, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

ProgramInfoPopupButton.propTypes = {
    progReg: PropTypes.object,
    program: PropTypes.object,
    sessions: PropTypes.array,
    isLoading: PropTypes.bool
};
function ProgramInfoPopupButton({ progReg, sessions, program, isLoading }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <IconButton aria-label="info" aria-describedby={id} variant="contained" onClick={handleClick}>
                <InfoOutlined />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {

                    isLoading
                        ? <Box p={10}>
                            <CircularProgress />
                        </Box>
                        : !(program && progReg)
                            ? <Box p={2}>{t("no_prog_info")}</Box>
                            : <Box p={2} maxWidth={400} overflow="auto">
                                <Tooltip title={program.description}>
                                    <Typography
                                        sx={{
                                            display: '-webkit-box',
                                            overflow: 'hidden',
                                            WebkitBoxOrient: 'vertical',
                                            WebkitLineClamp: 3,
                                        }}
                                        variant="body1"
                                    >
                                        {program.description}
                                    </Typography>
                                </Tooltip>
                                <Divider sx={{ margin: "1rem 0"}} />
                                <Box>
                                    <Typography variant="h6" mb={2}>{t("sessions")}</Typography>
                                    <Table aria-label="simple table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{t("Name")}</TableCell>
                                                <TableCell>{t("remaining_sessions")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sessions.map((session) => (
                                                <TableRow
                                                    key={session.id}
                                                >
                                                    <TableCell component="th" scope="row">{session.name} </TableCell>
                                                    <TableCell align="center">{session.remainingCount ?? session.count} / {session.count} </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>

                            </Box>
                }
            </Popover>
        </>
    )
}


export default ProgramInfoPopupButton;